import * as React from 'react'
import { times } from 'lodash';
import HelpSkeleton from './HelpSkeleton';
import { useHistory } from 'react-router';
import * as shortid from 'shortid';
import { toastr } from 'react-redux-toastr';
import { Button, Input, Label, CustomInput } from 'reactstrap';
import { useAuth } from 'src/modules/Auth/hooks/useAuth';
import { UserTypes } from 'src/modules/Auth/store/types';
import ConfirmationModal from 'src/share/components/ConfirmationModal/ConfirmationModal';
import { HelpService } from 'src/share/services/help';
import { IHelpCategory } from '../types/help';
import "./Help.css";

const initialCategory = {
  title: "",
  userTypes: []
}

function Help(): React.ReactElement {
  const history = useHistory();
  const [auth] = useAuth();
  const [category, setCategory] = React.useState(initialCategory);
  const [isLoading, setIsLoading] = React.useState(true);
  const [categories, setCategories] = React.useState<IHelpCategory[]>([]);
  const [isModalToggled, setIsModalToggled] = React.useState(false);
  const [userTypes, setUserTypes] = React.useState<Set<number>>(new Set());
  const isAdmin = auth.userType === UserTypes.ADMIN;
  React.useEffect(() => {
    fetchData();
  }, []);
  async function fetchData(): Promise<void> {
    try {
      const newCategories = await HelpService.getCategories();
      setCategories(newCategories);
      setIsLoading(false);
    } catch  {
      toastr.error('Error', 'There was a problem loading the categories data');
      setIsLoading(false);
    }
  }
  function handleModalToogled(): void {
    setIsModalToggled(prevIsToggled => !prevIsToggled);
  }
  function handleInputChanged(key, event): void {
    const value = event.target.value;
    setCategory(prevCategory => ({ ...prevCategory, [key]: value }));
  }
  function handleChecked(e): void {
    const key = UserTypes[e.target.name] as any;
    const checked = e.target.checked;
    if (checked) {
      setUserTypes((prevUserTypes) => (new Set(prevUserTypes).add(key)));
    }
    if (!checked && userTypes.has(key)) {
      const newUserTypes = new Set(userTypes);
      newUserTypes.delete(key);
      setUserTypes(newUserTypes);
    }
  }
  function categoryNameSaved(): boolean {
    return categories.find(c => c.title === category.title) ? true : false;
  }
  async function saveCategory(): Promise<void> {
    try {
      setIsLoading(true);
      const categoryId = shortid.generate();
      const newCategory = { ...category, categoryId, userTypes: Array.from(userTypes) }
      await HelpService.saveContent(newCategory, 'category');
      setTimeout(() => history.push(`/help/category/${newCategory.categoryId}`), 1000);
    } catch {
      toastr.error('Error', 'There was a problem connecting to the server');
      setIsLoading(false);
    }
  }
  return (
    <div className="help-center__container">
      <div className="white-background help-center">
        <div className="help-center__header">
          <h1 className="help-title">GMCNgine <span>Help Center</span></h1>
          <a href="mailto:help@gmcngine.com"><h1 className="help-contact-us">Contact Us</h1></a>
        </div>
        <div className="help-center__categories">
          {isLoading && times(10, (index) => <HelpSkeleton key={`help-skeleton-${index}`} />)}
          {!isLoading && categories.map(c => (
            <div className="category" key={c.categoryId}>
              <h2 className="category-title" onClick={() => history.push({ pathname: `/help/category/${c.categoryId}`, state: { category: c } })}>
                {c.title}{c.articles.length > 0 && <span className="help-articles-counter">{` (${c.articles.length})`}</span>}
              </h2>
              <ul>
                {c.articles.map(article => (
                  <li key={article.articleId} onClick={() => history.push(`/help/article/${c.title}/${c.categoryId}/${article.articleId}`)}>
                    <h3>{article.title}</h3>
                  </li>
                ))}
                {isAdmin &&
                  <li className="help-add-article" onClick={() => history.push(`/help/form/${c.title}/${c.categoryId}`)}>
                    Add new article
                  </li>}
              </ul>
            </div>
          ))}
        </div>
        <div className="help-center__actions">
          {isAdmin &&
            <Button className="btn btn-add-category btn-help" disabled={isLoading} onClick={handleModalToogled}>
              Add category
            </Button>}
        </div>
        <ConfirmationModal
          isOpen={isModalToggled}
          toggle={handleModalToogled}
          textInput={(
            <>
              <Input
                placeholder="Category title..."
                className="category-input mb-2"
                name="title"
                required={true}
                onChange={event => handleInputChanged('title', event)}
              />
              <div>
                <Label for="exampleCheckbox">Select the users who will be able to see this. If none is selected only admin users will have access.</Label>
                <div>
                  <CustomInput
                    type="checkbox"
                    label="Case Manager"
                    id="caseManager"
                    name="CASEMANAGER"
                    checked={userTypes.has(UserTypes.CASEMANAGER)}
                    onChange={handleChecked}
                  />
                  <CustomInput
                    type="checkbox"
                    label="Law Enforcement User"
                    name="LAWENFORCEMENTAGENT"
                    id="lawEnforcementUser"
                    checked={userTypes.has(UserTypes.LAWENFORCEMENTAGENT)}
                    onChange={handleChecked}
                  />
                </div>
              </div>
              {categoryNameSaved() ? <small className="form-text text-muted">This category title is already saved it in our system</small> : <small className="form-text text-muted">&nbsp;</small>}
            </>
          )}
          title={'Add category'}
          description={isLoading ? 'Saving category...' : 'Create new category'}
          disabledButton={categoryNameSaved() || category.title.length === 0}
          showButtons={!isLoading}
          loading={isLoading}
          onContinue={saveCategory}
        />
      </div>
    </div>
  )
}

export default Help;



// WEBPACK FOOTER //
// ./src/modules/UserSettings/Help/View/Help.tsx